import { render, staticRenderFns } from "./PageChanger.vue?vue&type=template&id=575c9c4c&"
import script from "./PageChanger.vue?vue&type=script&lang=js&"
export * from "./PageChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports